export default ({ request }) => ({
  ecomAmzListingFtySkuMonitorListApi(data = {}) {
    return request({
      url: '/ecom/amz/listing/fty/sku/monitor/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzListingFtySkuMonitorLevelGroupApi(data = {}) {
    return request({
      url: '/ecom/amz/listing/fty/sku/monitor/level/group',
      method: 'POST',
      data,
    })
  },
  ecomAmzListingFtySkuMonitorAddApi(data = {}) {
    return request({
      url: '/ecom/amz/listing/fty/sku/monitor/add',
      method: 'POST',
      data,
    })
  },
  ecomAmzListingFtySkuMonitorDelApi(data = {}) {
    return request({
      url: '/ecom/amz/listing/fty/sku/monitor/del',
      method: 'POST',
      data,
    })
  },
})
